import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { LOCALE_ID } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { MytoastrComponent } from './shared/components/dialogs/mytoastr/mytoastr.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MSAL_INSTANCE, MsalService } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { AuthService } from './service/auth/auth.service';
import { AuthInterceptor } from './service/auth/auth.interceptor';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { provideNgxMask, NgxMaskConfig } from 'ngx-mask';
import * as echarts from 'echarts/core';
import * as Charts from 'echarts/charts';
import * as Components from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { provideEchartsCore } from 'ngx-echarts';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.client,
      redirectUri: environment.redirectUri,
      authority: environment.authority,
    }
  });
}

const maskConfig: Partial<NgxMaskConfig> = {
  validation: false,
};

echarts.use([
  Components.TitleComponent, 
  Components.TooltipComponent, 
  Components.GridComponent, 
  Components.LegendComponent,
  Components.DataZoomComponent,
  Components.MarkAreaComponent,
  Components.MarkLineComponent,
  Components.VisualMapComponent,
  Charts.BarChart,
  Charts.LineChart,
  Charts.ScatterChart,
  Charts.PieChart,
  Charts.HeatmapChart,
  Charts.CustomChart,
  CanvasRenderer
]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideToastr({
      toastComponent: MytoastrComponent,
      timeOut: 6000,
      extendedTimeOut: 1000,
      tapToDismiss: true,
    }),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: HTTP_INTERCEPTORS,
      useFactory: (authService: AuthService, router: Router, dialog: MatDialog) => {
        return new AuthInterceptor(authService, router, dialog);
      },
      multi: true,
      deps: [AuthService, Router, MatDialog]
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    MsalService,
    AuthService,
    provideNgxMask(maskConfig),
    AuthInterceptor,
    provideEchartsCore({ echarts }),
  ]
};
